<template>
  <Dialog
    test-id="modalSuccessAndFail"
    v-if="msjEnable"
    :visible="true"
    :style="{ width: '500px' }"
    :contentStyle="{}"
    :modal="true"
    :closable="false"
    ref="modalUpdate"
  >
    <template #header>
      <div v-if="icon != {}" class="text-center" style="width: 100%">
        <i :class="icon.type" :style="icon.style"></i>
      </div>
    </template>
    <!-- Content -->
    <div class="text-center">
      <h4 test-id="textoModal" class="ml-3">{{ mensajeDialog }}</h4>
    </div>
    <template #footer>
      <div class="text-center">
        <Button
          test-id="buttomAceptarModal"
          v-if="buttomAceptar.buttom"
          :label="aceptar"
          icon="pi pi-check"
          @click="aceptarDialog('Aceptar')"
          autofocus
        />
        <Button
          v-if="buttomCancelar.buttom"
          :label="cancelar"
          icon="pi pi-times"
          @click="aceptarDialog('Cancelar')"
          autofocus
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import { useRouterCompat } from "@/composables/index.js";

const { router, route } = useRouterCompat();

const props = defineProps({
  aceptar: {
    type: String,
    default: "Aceptar",
  },
  cancelar: {
    type: String,
    default: "Cancelar",
  },
  msjEnable: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: Object,
    default: "",
  },
  buttomAceptar: {
    type: Object,
    default: () => ({ buttom: true, action: false }),
  },
  buttomCancelar: {
    type: Object,
    default: () => ({ buttom: false, action: false }),
  },
  mensajeDialog: {
    type: String,
    default: "",
  },
  routerPush: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:msjEnable", "update:icon", "Aceptar"]);

const modalEnable = ref(false);

const aceptarDialog = (select) => {
  switch (select) {
    case "Aceptar": {
      if (props.buttomAceptar.routerPush) {
        if (props.buttomAceptar.routerPush == route.fullPath) {
          router.go();
        } else {
          router.push(props.buttomAceptar.routerPush);
        }
      }
      if (props.buttomAceptar.action == false) {
        emit("update:msjEnable", false); //ponemos msjEnable como false
        emit("update:icon", {});
      } else {
        emit("update:msjEnable", false); //ponemos msjEnable como false
        emit("Aceptar", select);
      }
      break;
    }
    case "Cancelar": {
      emit("update:msjEnable", false); //ponemos msjEnable como false
      // emit("Cancelar", select);
      break;
    }
  }
};
</script>

<style scoped></style>
